import type { ReactNode } from 'react';

/**
 * THE horizontal-scroll pattern for data tables (mobile fix, Aug 2026):
 * the document must never scroll sideways — a table wider than the
 * viewport scrolls inside this wrapper, within its card. Wrap the
 * <table> itself and keep the surface/card outside, so every screen
 * clips and scrolls identically. If you're adding a table, use this;
 * do not hand-roll another overflow container.
 */
export function TableScroll({ children }: { children: ReactNode }) {
  return <div className="overflow-x-auto">{children}</div>;
}
